import React from "react";
import DetailsNavbar from "../DetailsNavbar/DetailsNavbar";
import { Outlet } from "react-router-dom";
import Footer from "../Footer/Footer";

const PublicLayout = () => {
  return (
    <>
      <DetailsNavbar />
     
                <Outlet />
              <Footer/>
    </>
  );
};

export default PublicLayout;